import { cn } from "@/lib/utils";

interface SeparatorWithTextProps {
  children: React.ReactNode;
  className?: string;
}

export function SeparatorWithText({ children, className }: SeparatorWithTextProps) {
  return (
    <div className={cn("relative", className)}>
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-borderLight" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-background px-2 text-primary font-semibold">{children}</span>
      </div>
    </div>
  );
}
